import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { SharedCommonModule } from "app/back-office/shared/common.module";
import { PaginationComponent } from "./pagination.component";

@NgModule({
  imports: [
    NgbModule,
    CommonModule,
    SharedCommonModule,
    TranslateModule.forChild()
  ],
  declarations: [
    PaginationComponent
  ],
  exports: [
    PaginationComponent
  ]
})
export class PaginationModule { }
